import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "../../components/admin/AdminLayout";
import { MagnifyingGlass, Crown, Star } from "@phosphor-icons/react";

export default function AdminSubscriptions() {
  const [subs, setSubs] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchSubs = async (q = "") => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/subscriptions?search=${encodeURIComponent(q)}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("rs_token")}` },
      });
      if (!res.ok) throw new Error("Failed to load");
      setSubs(await res.json());
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSubs(); }, []);
  useEffect(() => { const t = setTimeout(() => fetchSubs(search), 300); return () => clearTimeout(t); }, [search]);

  const planIcon = (plan) => {
    if (plan === "pro") return <Crown size={14} className="text-yellow-500" />;
    if (plan === "premium") return <Star size={14} className="text-purple-500" />;
    return null;
  };

  return (
    <AdminLayout>
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <div className="relative flex-1 max-w-md">
            <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-muted)]" />
            <input placeholder="Search..." className="input-pop pl-9 w-full" value={search} onChange={e => setSearch(e.target.value)} />
          </div>
        </div>
        <div className="card-pop overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2" style={{ borderColor: "var(--border)" }}>
                <th className="py-2 px-3 text-left font-bold">Owner</th>
                <th className="py-2 px-3 text-left font-bold">Plan</th>
                <th className="py-2 px-3 text-left font-bold">Status</th>
                <th className="py-2 px-3 text-left font-bold">Trial Ends</th>
                <th className="py-2 px-3 text-left font-bold">Since</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={5} className="py-8 text-center text-[var(--ink-muted)]">Loading...</td></tr>}
              {!loading && subs.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-[var(--ink-muted)]">No subscriptions</td></tr>}
              {subs.map((s) => (
                <tr key={s.id} className="border-b hover:bg-gray-50" style={{ borderColor: "var(--border)" }}>
                  <td className="py-2 px-3">
                    <div className="font-medium">{s.name}</div>
                    <div className="text-xs text-[var(--ink-muted)]">{s.email}</div>
                  </td>
                  <td className="py-2 px-3">
                    <span className="flex items-center gap-1 text-xs font-bold capitalize">
                      {planIcon(s.plan)}{s.plan || "free"}
                    </span>
                  </td>
                  <td className="py-2 px-3">
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${s.plan_status === "active" ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-600"}`}>
                      {s.plan_status || "active"}
                    </span>
                  </td>
                  <td className="py-2 px-3 text-sm">{s.trial_ends_at ? new Date(s.trial_ends_at).toLocaleDateString() : "-"}</td>
                  <td className="py-2 px-3 text-sm">{new Date(s.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}